import { Button, Flex, useBreakpointValue } from "@chakra-ui/react";
import {
    subMonths
} from 'date-fns';
import { useMemo } from "react";
import type { HistoricalPeriod, UseTimeRangeReturn } from "../hooks";
import { getHistoricalLabel } from "../hooks";

// Helper function to generate last few months for buttons
const generateLastMonths = (count: number = 4) => {
    const now = new Date();
    const months: { value: HistoricalPeriod; label: string }[] = [];

    months.push({
        value: 'THIS_MONTH',
        label: getHistoricalLabel('1M', 'THIS_MONTH', false),
    });

    for (let i = 1; i <= count - 1; i++) {
        const date = subMonths(now, i);
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const value = `M${month}-${year}`;
        months.push({
            value,
            label: getHistoricalLabel('1M', value, false),
        });
    }

    return months;
};

interface QuickMonthSelectorProps {
    periodType: UseTimeRangeReturn['periodType'];
    setPeriodType: UseTimeRangeReturn['setPeriodType'];
    historicalPeriod: UseTimeRangeReturn['historicalPeriod'];
    setHistoricalPeriod: UseTimeRangeReturn['setHistoricalPeriod'];
}

export const QuickMonthSelector = ({
    periodType,
    setPeriodType,
    historicalPeriod,
    setHistoricalPeriod
}: QuickMonthSelectorProps) => {
    const lastMonthsCount = useBreakpointValue({ base: 3, md: 4 });

    // Memoized last few months
    const lastFewMonths = useMemo(() => generateLastMonths(lastMonthsCount), [lastMonthsCount]);

    // Handle month button click
    const handleMonthButtonClick = (month: { value: HistoricalPeriod; label: string }) => {
        setPeriodType('1M');
        setHistoricalPeriod(month.value);
    };

    return (
        <Flex gap={1}>
            {lastFewMonths.map((month) => (
                <Button
                    key={month.value}
                    variant={historicalPeriod === month.value && periodType === '1M' ? 'solid' : 'ghost'}
                    py={2}
                    px={4}
                    onClick={() => handleMonthButtonClick(month)}
                >
                    {month.label}
                </Button>
            ))}
        </Flex>
    );
};
